module.exports = __webpack_public_path__ + "static/media/card-flurry.0bece8f4.png";